import { useEffect } from 'react';
import { usePersonaProfiles } from '@/hooks/usePersonaCatalog';
import { LoadingScreen } from '@/components/layout/LoadingScreen';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';
import SizingPage from './SizingPage';

export default function SizingPageWithPersonas() {
  const { data: personas, isLoading, error } = usePersonaProfiles();

  // Seed persona profiles into localStorage once, after they have loaded.
  useEffect(() => {
    if (!personas || personas.length === 0) return;
    if (typeof window === 'undefined') return;

    try {
      console.log('[SizingPageWithPersonas] Initial personas for unified sizing', {
        personaIds: personas.map((p) => p.id),
      });

      console.log(
        '[SizingPageWithPersonas] writing personas to localStorage for default seeding'
      );

      window.localStorage.setItem(
        'personaProfilesForSizing',
        JSON.stringify(personas)
      );
    } catch {
      // best effort only
    }
  }, [personas]);

  if (isLoading) {
    return <LoadingScreen message="Loading persona profiles..." />;
  }

  if (error || !personas || personas.length === 0) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <Alert variant="destructive" className="max-w-md">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Persona Profiles Required</AlertTitle>
          <AlertDescription>
            Unable to load persona profiles from database. Please ensure the
            personas table is seeded.
            {error && (
              <div className="mt-2 text-sm opacity-80">
                Error: {error instanceof Error ? error.message : 'Unknown error'}
              </div>
            )}
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return <SizingPage />;
}
